export function resolveClientBuild(sourceUrl) {
  const value = String(sourceUrl || "");
  const match = value.match(/\/assets\/([^/?#]+)\.js(?:[?#].*)?$/);
  if (match) {
    return match[1];
  }
  if (!value) {
    return "dev";
  }
  return value.split("/").pop() || "dev";
}

export function buildTelemetryEvent(event, clientBuild, now = new Date()) {
  const eventName = String(event?.eventName || "").trim();
  if (!eventName) {
    return null;
  }
  return {
    event_name: eventName,
    surface: event?.surface ? String(event.surface) : null,
    route: event?.route ? String(event.route) : null,
    outcome: event?.outcome ? String(event.outcome) : "success",
    duration_ms: Number.isFinite(event?.durationMs) ? Math.max(0, Math.round(event.durationMs)) : null,
    detail: event?.detail ? String(event.detail).slice(0, 255) : null,
    client_build: String(event?.clientBuild || clientBuild || "dev"),
    client_occurred_at: event?.clientOccurredAt || now.toISOString(),
    metadata: event?.metadata && typeof event.metadata === "object" ? event.metadata : {},
  };
}

export function drainTelemetryQueue(queue, clientBuild, now = new Date()) {
  const items = Array.isArray(queue) ? queue.splice(0, 20) : [];
  return items
    .map((item) => buildTelemetryEvent(item, clientBuild, now))
    .filter(Boolean);
}
